import { useCallback } from 'react';

interface SubscriptionState {
  subscriptionType?: string;
  error?: string;
  disableCtas?: boolean;
}

export const SUBSCRIPTION_STATE_STORAGE_KEY = 'subscription_state';

const STORAGE_KEY = SUBSCRIPTION_STATE_STORAGE_KEY;

/**
 * Hook for managing subscription state during the Drive sign-up flow.
 */
export const useSubscriptionState = () => {
  const getSubscriptionState = useCallback((): SubscriptionState | null => {
    try {
      const stored = sessionStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  }, []);

  const setSubscriptionState = useCallback((state: SubscriptionState) => {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch {
      // Silently fail if storage is unavailable
    }
  }, []);

  const clearSubscriptionState = useCallback(() => {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch {
      // Silently fail if storage is unavailable
    }
  }, []);

  return { getSubscriptionState, setSubscriptionState, clearSubscriptionState };
};
